import { createContext } from 'react';


export const initialState = {
    teacherColumns: [
        {
            title: 'Name',
            name: 'name'
        },
        {
            title: 'Email',
            name: 'email',

        },
    ],
    certificateTags: [
        { id: 'qwerty-70D7-40D4-B736-35725740E018', name: 'Init' },
        { id: '16ae9aef-30b9-45eb-8019-bbecfe383432', name: 'Cloud' },
        { id: '67F3EA5A-70D7-40D4-B736-35725740E018', name: 'DevOps' },
    ],
    selectedOption: null,
};

export const reducer = (state, action) => {
    console.log("exl-store", { state, action });
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state,
                tableSize: action.totalRows,
            };
        case 'FETCH_CERTIFICATE_TAGS':
            return {
                ...state,
                certificateTags: action.certificateTags,
            };

        case 'SET_COURSE_NAME':
            return {
                ...state,
                name: action.payload,
            };
        case 'SET_COURSE_TEACHER':
            return {
                ...state,
                teacher: action.payload,
            };
        case 'SET_COURSE_DESCRIPTION':
            return {
                ...state,
                description: action.payload,
            };
        case 'SET_COURSE_START_DATE':
            return {
                ...state,
                startDate: action.payload,
            };
        case 'SET_COURSE_END_DATE':
            return {
                ...state,
                endDate: action.payload,
            };
        case 'SET_COURSE_BOOKINGS':
            return {
                ...state,
                bookings: action.payload,
            };
        case 'SELECTED_OPTION':
            return {
                ...state,
                selectedOption: action.payload,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
